"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var text_field_component_1 = __importDefault(require("./text-field.component"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.DisableStepArrow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n"], ["\n  /* Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n"])));
exports.DisableStepArrow.displayName = 'DisableStepArrow';
var NumberField = function (props) {
    var parentOnChange = props.onChange, value = props.value, significantDigits = props.significantDigits;
    var onChange = function (value) {
        if (parentOnChange) {
            parentOnChange(typeof value === 'number' ? value : parseFloat(value));
        }
    };
    return (react_1.default.createElement(exports.DisableStepArrow, null,
        react_1.default.createElement(text_field_component_1.default, __assign({}, props, { onChange: onChange, type: 'number', value: significantDigits ? value.toFixed(significantDigits) : value }))));
};
NumberField.displayName = 'NumberField';
exports.default = NumberField;
var templateObject_1;
//# sourceMappingURL=number-field.component.js.map